import * as React from 'react';
import { IAdminItemCardButtonsProps } from 'models/itemcard/adminitemcardbuttons';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
require('./style.css');

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdminItemCardButtons extends React.Component<IAdminItemCardButtonsProps, any> {
	public render() {
		let deleteButton: JSX.Element = null;
		if (this.props.deleteItem) {
			deleteButton = (
				<span className="adminCardButton deleteButton" onClick={this.props.deleteItem}>
					<img src={require('containers/Html/icons/actionIcons/remove.svg')} />
				</span>
			);
		}

		let copyButton: JSX.Element = null;
		if (this.props.copyItem) {
			copyButton = (
				<span className="adminCardButton copyButton" onClick={this.props.copyItem}>
					<img src={require('containers/Html/icons/actionIcons/copy.svg')} />
				</span>
			);
		}

		let viewButton: JSX.Element = null;
		if (this.props.viewItem) {
			viewButton = (
				<span className="adminCardButton viewButton" onClick={this.props.viewItem}>
					<img src={require('containers/Html/icons/actionIcons/view.svg')} />
				</span>
			);
		}

		let settingsButton: JSX.Element = null;
		if (this.props.settingsItem) {
			settingsButton = (
				<span className="adminCardButton settingsButton" onClick={this.props.settingsItem}>
					<img src={require('containers/Html/icons/actionIcons/settings.svg')} />
				</span>
			);
		}

		let publishButton: JSX.Element = null;
		if (this.props.publishItem) {
			publishButton = (
				<span className="adminCardButton settingsButton" onClick={this.props.publishItem}>
					{this.props.t('BSPortal_Common_Publish').toUpperCase()}
				</span>
			);
		}

		let archiveButton: JSX.Element = null;
		if (this.props.archiveItem) {
			archiveButton = (
				<span className="adminCardButton settingsButton" onClick={this.props.archiveItem}>
					<img src={require('containers/Html/icons/actionIcons/archive.png')} />
				</span>
			);
		}

		return (
			<div className="itemCardButtons">
				{publishButton}
				{settingsButton}
				{copyButton}
				{archiveButton}
				{deleteButton}
				{viewButton}
			</div>
		);
	}
}

export { AdminItemCardButtons };
